import React from 'react'

import SpacedItems from 'shared/components/ui/SpacedItems'

import { ReportsLayout } from 'ducks/reports/layout'
import * as CustomPropTypes from 'ducks/reports/propTypes'

import ProductivityOverview from '../ProductivityOverview'

Page.propTypes = {
  queryBase: CustomPropTypes.queryBase.isRequired,
}

export default function Page({ queryBase }) {
  return (
    <ReportsLayout>
      <SpacedItems.Container direction="vertical" gap="ginormous">
        <SpacedItems.Item>
          <ProductivityOverview queryBase={queryBase} />
        </SpacedItems.Item>
      </SpacedItems.Container>
    </ReportsLayout>
  )
}
